import {Helmet} from "react-helmet-async";
// import type {SEOProps} from "../../utils/typesInterfaces.ts";

const Seo = ({  title, description, canonical, openGraph, twitter, author,}: any) => {
    return (
        <Helmet>
            <title>{title}</title>

            <meta name="description" content={description}/>
            <link rel="canonical" href={canonical}/>

            {/* Open Graph */}
            <meta property="og:title" content={openGraph.title}/>
            <meta property="og:description" content={openGraph.description}/>
            <meta property="og:image" content={openGraph.image}/>
            <meta property="og:url" content={openGraph.url}/>
            <meta property="og:type" content={openGraph.type || "website"}/>
            {openGraph.locale && (
                <meta property="og:locale" content={openGraph.locale}/>
            )}

            {/* Twitter */}
            <meta name="twitter:card" content={twitter.card}/>
            <meta name="twitter:title" content={twitter.title}/>
            <meta name="twitter:description" content={twitter.description}/>
            <meta name="twitter:image" content={twitter.image}/>

            {author && <meta name="author" content={author}/>}
        </Helmet>
    );
};

export default Seo;